import type { WebsiteFull } from 'common/dataService/types/websitesFullTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type WebsitesFullState = {
  fetching: FetchingStatus | null;
  value: WebsiteFull | null;
  updating: FetchingStatus | null;
};

const initialState: WebsitesFullState = {
  fetching: null,
  value: null,
  updating: null,
};

function setFetchingFunction(state: WebsitesFullState, action: PayloadAction<WebsitesFullState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setWebsitesFullFunction(state: WebsitesFullState, action: PayloadAction<WebsitesFullState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}
function setUpdatingFunction(state: WebsitesFullState, action: PayloadAction<WebsitesFullState['updating']>) {
  return {
    ...state,
    updating: action.payload,
  };
}

const slice = createSlice({
  name: 'dataService.websitesFull.websitesFull',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setWebsitesFull: setWebsitesFullFunction,
    setUpdating: setUpdatingFunction,
  },
});

export const { setFetching, setWebsitesFull, setUpdating } = slice.actions;
export default slice.reducer;
